import { Icon } from '@iconify/react';
import {
    VISITOR_TYPE_STYLE,
    VISITOR_TYPE_ICON,
    ID_PROOF_LABEL,
    ID_PROOF_ICON,
    typeLabel,
    isBlocked,
    maskIdNumber,
} from '../visitorConstants';

// The three pills that identify a visitor at a glance. They appear in the
// table, the card grid and the profile header, so they live here rather than
// being re-declared per screen.

export const VisitorTypeBadge = ({ value }) => (
    <span className={`tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-semibold ${VISITOR_TYPE_STYLE[value] || VISITOR_TYPE_STYLE.OTHER}`}>
        <Icon icon={VISITOR_TYPE_ICON[value] || VISITOR_TYPE_ICON.OTHER} className="tw-text-xs" />
        {typeLabel(value)}
    </span>
);

export const VisitorStatusBadge = ({ visitor }) => (
    isBlocked(visitor) ? (
        <span
            className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-semibold tw-rounded-full tw-bg-rose-100 tw-text-rose-700 tw-shrink-0"
            title={visitor.blocked_reason || 'Blocked'}
        >
            <Icon icon="mdi:block-helper" className="tw-text-[9px]" />
            Blocked
        </span>
    ) : (
        <span className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-semibold tw-rounded-full tw-bg-emerald-100 tw-text-emerald-700 tw-shrink-0">
            <Icon icon="mdi:check-circle-outline" className="tw-text-[9px]" />
            Active
        </span>
    )
);

// `withNumber` shows the masked tail alongside the document type — used in the
// table, where the number helps tell two records apart. The card grid passes it
// off and shows the type alone.
export const IdProofBadge = ({ type, number, withNumber = false, pill = false }) => {
    if (!type) return <span className="tw-text-gray-300">—</span>;

    const label = ID_PROOF_LABEL[type] || type;
    const icon = ID_PROOF_ICON[type] || ID_PROOF_ICON.OTHER;

    if (pill) {
        return (
            <span className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-semibold tw-bg-gray-100 tw-text-gray-600">
                <Icon icon={icon} className="tw-text-xs" />
                {label}
            </span>
        );
    }

    return (
        <span className="tw-inline-flex tw-items-center tw-gap-1">
            <Icon icon={icon} className="tw-text-gray-400" />
            <span>{label}</span>
            {withNumber && number && (
                <span className="tw-font-mono tw-text-[10px] tw-text-gray-500">{maskIdNumber(number)}</span>
            )}
        </span>
    );
};
